import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const EditDuration = ({ show, onClose, id, onUpdated }) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
    
  // Form state
  const [durationName, setDurationName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);

  // Units options for select
  const [itemQuantityOptions, setItemQuantityOptions] = useState([]);

  // Loading state (optional)
  const [loading, setLoading] = useState(false);

  // Fetch units for the select dropdown
  useEffect(() => {
    const fetchUnitsByCategory = async () => {
      try {
        const response = await axios.get(`${baseURL}/manageunit/by-category`, {
          params: { unit_category_sno: 5 },
        });

        if (response.data.success) {
          const options = response.data.data.map((unit) => ({
            value: unit.unit_name, // <-- IMPORTANT: Use sno for backend update
            label: unit.unitslug_name,
          }));
          setItemQuantityOptions(options);
        } else {
          setItemQuantityOptions([]);
        }
      } catch (err) {
        console.error("Error fetching units:", err);
        setItemQuantityOptions([]);
      }
    };

    if (baseURL) {
      fetchUnitsByCategory();
    }
  }, [baseURL]);

  // Fetch duration details by id and set form fields
  useEffect(() => {
    if (!id) return;

    const fetchDuration = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseURL}/duration/${id}`);

        if (response.data.message === "Duration fetched successfully") {
          const data = response.data.data;

          setDurationName(data.duration_name || "");
          setDescription(data.description || "");

          // Find the option matching the duration's unit sno
          const unitOption = itemQuantityOptions.find(
            (opt) => opt.value === data.unit
          );

          // If options not loaded yet, we can wait or set null and set later:
          setSelectedOption(unitOption || null);
        }
      } catch (error) {
        console.error("Error fetching duration:", error);
      }
      setLoading(false);
    };

    fetchDuration();
  }, [id, baseURL, itemQuantityOptions]);

  // Handle form submission
  const handleUpdate = async () => {
    if (!durationName || !selectedOption) {
      alert("Please fill all required fields");
      return;
    }

    try {
      const response = await axios.post(`${baseURL}/duration/${id}`, {
        duration_name: durationName,
        unit: selectedOption.value,
        description,
      });

      if (response.status === 200) {
        onUpdated && onUpdated(response.data.data);
        onClose();
        toast.success("Duration updated successfully!");
      }
    } catch (error) {
      console.error("Update failed:", error);
      // alert("Failed to update duration.");
      toast.error("Duration Updation Failed");
    }
  };

  return (
    <Modal show={show} size="md" onHide={onClose}>
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: "#3ab384" }}>
          <h3 className="modal-title text-white">Update Duration</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>

        <div className="modal-body">
          {loading ? (
            <div>Loading...</div>
          ) : (
            <div className="row">
              <div className="col-lg-6 mb-2">
                <label className="text-black font-w500 fs-7">
                  Duration<span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Duration"
                  value={durationName}
                  onChange={(e) => setDurationName(e.target.value)}
                />
              </div>

              <div className="col-lg-6 mb-2">
                <label className="text-black font-w500 fs-7">
                  Unit<span className="required">*</span>
                </label>
                <Select
                  value={selectedOption}
                  onChange={setSelectedOption}
                  options={itemQuantityOptions}
                  placeholder="Select Units"
                />
              </div>

              <div className="col-lg-12 mb-2">
                <label className="text-black font-w500 fs-7">Description</label>
                <textarea
                  rows={4}
                  className="form-control h-auto"
                  name="comment"
                  placeholder="Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
          )}
          <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={handleUpdate}
              disabled={loading}
            >
              Update Duration <i className="fas fa-angle-double-right ms-2"></i>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditDuration;
